import { render, staticRenderFns } from "./ProductosNuevos.vue?vue&type=template&id=2bfbbde9&scoped=true&"
import script from "./ProductosNuevos.vue?vue&type=script&lang=js&"
export * from "./ProductosNuevos.vue?vue&type=script&lang=js&"
import style0 from "./ProductosNuevos.vue?vue&type=style&index=0&id=2bfbbde9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfbbde9",
  null
  
)

export default component.exports